import { WITHDRAW_LIST, PLAYER_BANK_DETAILS } from "./types";
import { API_URLS } from "../../config/apiUrls";
import { axiosService } from "../../utils/axiosService";
import { Toaster } from "../../utils/toaster";
import { APP_CONST } from "../../config/const";
import { AxiosError } from "axios";

const API_HOST_V2 = process.env.REACT_APP_API_HOST_V2;

export const getAccountStatement = async (data) => {
  try {
    return await axiosService.get(
      `${API_URLS.USER.ACCOUNT_STATEMENT}/${data?.from}/${data?.to}`
    );
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Something went wrong"
      );
    }
  }
};

// despoit create

export const createDeposit = async (payload) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.CREATE_DEPOSIT,
      payload,
      {
        headers: {
          "Content-Type": `multipart/form-data`,
        },
      }
    );
    return result;
  } catch (err) {
    console.log(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to create request"
      );
    }
  }
};

export const createWithDrawRequest = async (payload, setFunc) => {
  try {
    return await axiosService.post(
      API_URLS.USER.CREATE_WITHDRAW_REQUEST,
      payload
    );
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response?.data?.message);
    }
    if (setFunc) {
      setFunc(false);
    }
    console.debug(err);
  }
};

// get withdrawlist

export const getWithdrawList = () => (dispatch) => {
  try {
    const result = axiosService.get(
      `${API_URLS.USER.GET_WITHDRAW_LIST}?skip=0`
    );
    result.then((res) => {
      dispatch({
        type: WITHDRAW_LIST,
        payload: res?.data?.data?.data?.withdrawls,
      });
    });
  } catch (err) {
    console.debug(err);
  }
};

// Get bonus list
// export const getBonusList = () => {
//   console.log("Anyyyyy");

//   const result = axiosService.request({
//     url: "https://spmback.gbet567.com/player/bonus/claims",
//     headers: {
//       "xu-auth":
//         "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtc3RyaWQiOjgxNDk2LCJpYXQiOjE2ODU2MzMxNjN9.swqGlpPpsPOLOD0QYEhkvIyEBVAUM76G-G3PfsPink0",
//     },
//   });
//   result
//     .then((res) => {
//       console.log(res, "responseeeee");
//     })
//     .catch((error) => console.log(error, "Errorrrr"));
//   console.log("sdcfsdfsdfd");
// };

// cancel request

export const cancelWithdrawList = (payload) => {
  try {
    return axiosService.post(API_URLS.USER.CANCEL_WITHDRAW_REQUEST, payload);
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to cancel request"
      );
    }
  }
};

export const getOnlinePaymentLink = async (data) => {
  try {
    // const result = await axiosService.post(API_URLS.USER.FLOXY_DEPOSIT, data);
    const result = await axiosService.post(
      API_URLS.USER.FASTPAYME_DEPOSIT,
      data
    );
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }

    return null;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

export const updateDepositAmount = async (payload) => {
  try {
    let headers = {};
    console.log("payload", payload);
    if (payload?.isMultiPart == true) {
      headers["Content-Type"] = `multipart/form-data`;
    }
    const result = await axiosService.post(
      payload.url,
      payload?.isMultiPart ? objectToFormData(payload?.data) : payload?.data,
      {
        headers,
      }
    );
    return result;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Payment Failed"
      );
    }
    console.debug(err);
  }
};

export const getAllGateways = async () => {
  try {
    return await axiosService.get(API_URLS.USER.GET_ALL_GATEWAYS);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to get gateways"
      );
    }
  }
};

// export const addPlayerBankDetails = async (payload) => {
//   try {
//     return await axiosService.post(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
//   } catch (err) {
//     if (err instanceof AxiosError) {
//       Toaster(
//         APP_CONST.TOAST_TYPE.ERROR,
//         err.response.data?.message || "Failed to add details"
//       );
//     }
//     console.debug(err);
//   }
// };

// export const getPlayerBankDetails = async (query) => {
//   try {
//     return await axiosService.get(
//       `${API_URLS.USER.PLAYER_BANK_DETAILS}${query}`
//     );
//   } catch (err) {
//     if (err instanceof AxiosError) {
//       Toaster(
//         APP_CONST.TOAST_TYPE.ERROR,
//         err.response.data?.message || "Failed to get details"
//       );
//     }
//   }
// };

// export const updatePlayerBankDetails = async (payload) => {
//   try {
//     return await axiosService.patch(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
//   } catch (err) {
//     if (err instanceof AxiosError) {
//       Toaster(
//         APP_CONST.TOAST_TYPE.ERROR,
//         err.response.data?.message || "Failed to get details"
//       );
//     }
//   }
// };

// export const detelePlayerBankRecord = async (id) => {
//   try {
//     return await axiosService.delete(`${API_URLS.USER.PLAYER_BANK_DETAILS}`, {
//       data: {
//         id: id,
//       },
//     });
//   } catch (err) {
//     if (err instanceof AxiosError) {
//       Toaster(
//         APP_CONST.TOAST_TYPE.ERROR,
//         err.response.data?.message || "Failed to delete record"
//       );
//     }
//   }
// };

export const addPlayerBankDetails = async (payload) => {
  try {
    return await axiosService.post(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to add details"
      );
    }
    console.debug(err);
  }
};

export const getPlayerBankDetails = (query) => (dispatch) => {
  try {
    const result = axiosService.get(
      `${API_URLS.USER.PLAYER_BANK_DETAILS}${query}`
    );
    result.then((res) => {
      dispatch({
        type: PLAYER_BANK_DETAILS,
        payload: res?.data?.data?.data,
      });
    });
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to get details"
      );
    }
  }
};

export const updatePlayerBankDetails = async (payload) => {
  try {
    return await axiosService.patch(API_URLS.USER.PLAYER_BANK_DETAILS, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to get details"
      );
    }
  }
};

export const detelePlayerBankRecord = async (id) => {
  try {
    return await axiosService.delete(`${API_URLS.USER.PLAYER_BANK_DETAILS}`, {
      data: {
        id: id,
      },
    });
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to delete record"
      );
    }
  }
};
export const createDepositRequestHandler = async (payload) => {
  // console.log({
  //   payload,
  // });
  try {
    return axiosService.post(API_URLS.USER.CREATE_DEPOSIT, payload);
  } catch (err) {
    Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
    console.debug(err);
  }
};

// Get Kyc documents
export const getKycDocuments = async () => {
  try {
    return await axiosService.get(`${API_HOST_V2}${API_URLS.USER.PLAYER_KYC}`);
  } catch (err) {
    console.log(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data.message || "Failed to get documents"
      );
    }
  }
};

// Upload kyc documents
export const uploadKycDocuments = async (payload) => {
  try {
    return await axiosService.post(
      `${API_HOST_V2}${API_URLS.USER.PLAYER_KYC}`,
      payload,
      {
        headers: {
          "Content-Type": `multipart/form-data`,
        },
      }
    );
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data.message || "Failed to upload documents"
      );
    }
  }
};

// Upload kyc documents
export const updateKycDocuments = async (payload) => {
  try {
    return await axiosService.put(
      `${API_HOST_V2}${API_URLS.USER.PLAYER_KYC}`,
      payload,
      {
        headers: {
          "Content-Type": `multipart/form-data`,
        },
      }
    );
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data.message || "Failed to update documents"
      );
    }
  }
};

/**
 * Get one gateway from server
 * @param {string} gtwId
 */

export const getOneGateway = async (gtwId) => {
  try {
    return await axiosService.get(`${API_URLS.USER.GET_ALL_GATEWAYS}/${gtwId}`);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to get gateway"
      );
    }
  }
};

function objectToFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let propertyName in obj) {
    if (!obj.hasOwnProperty(propertyName) || obj[propertyName] === undefined) {
      continue;
    }

    if (namespace) {
      formKey = `${namespace}[${propertyName}]`;
    } else {
      formKey = propertyName;
    }

    if (
      typeof obj[propertyName] === "object" &&
      !(obj[propertyName] instanceof File) &&
      obj[propertyName] !== null
    ) {
      objectToFormData(obj[propertyName], fd, formKey);
    } else if (obj[propertyName] === null) {
      fd.append(formKey, "");
    } else {
      fd.append(formKey, obj[propertyName]);
    }
  }
  return fd;
}

/**
 * Request withdraw OTP
 */

export const requestWithdrawOtp = async (payload) => {
  try {
    return await axiosService.post(API_URLS.USER.REQUEST_WITHDRAW_OTP, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Failed to generate withdraw OTP");
    }
  }
};

/**
 * Create dynamic manual withdraw request
 */
export const createDynamicManualWithdrawRequest = async ({
  payload,
  isMultiPart = false,
}) => {
  try {
    let headers = {};
    if (isMultiPart) {
      headers["Content-Type"] = `multipart/form-data`;
    }
    return await axiosService.post(
      API_URLS.USER.DYNAMIC_MANUAL_WITHDRAW,
      isMultiPart ? objectToFormData(payload) : payload,
      {
        headers: headers,
      }
    );
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to create request"
      );
    }
  }
};
